// Helpers for marketplace product links.

/** Build the public marketplace product page URL for a given platform + SKU. */
export function mpProductUrl(platform: string, sku: string | null): string | null {
  if (!sku) return null;
  if (platform === "wb") return `https://www.wildberries.ru/catalog/${sku}/detail.aspx`;
  if (platform === "ozon") return `https://www.ozon.ru/product/${sku}`;
  return null;
}
